const isArray = (input: any) => !!input && Array.isArray(input);

export const ArrayHelper = {
    isArray,
};
